{
  "el": {
    "snippets": {
      "labels": {
        "cancel": "Ακύρωση",
        "confirm": "Επιβεβαίωση",
        "create": "Δημιουργία αποσπάσματος",
        "delete": "Διαγραφή",
        "edit": "Επεξεργασία",
        "editTitle": "Επεξεργασία αποσπάσματος",
        "initMessage": "Επίλεξε ένα απόσπασμα για να το δεις εδώ σε προεπισκόπηση.",
        "language": "Γλώσσα",
        "linkable": "Τύπος",
        "linkableClient": "Ομάδα",
        "linkableEmployee": "Προσωπικό",
        "linkablePartner": "Συνεργάτης",
        "manage": "Διαχείριση των αποσπασμάτων σου",
        "manageMessage": "Ή κάνε κλικ εδώ για να διαχειριστείς όλα τα αποσπάσματά σου στις ρυθμίσεις της εταιρείας",
        "message": "Μήνυμα",
        "messageError": "Συμπλήρωσε ένα μήνυμα",
        "new": "Νέο απόσπασμα",
        "noSnippets": "Δεν έχεις ακόμη αποσπάσματα.",
        "preview": "Προεπισκόπηση",
        "save": "Αποθήκευση",
        "search": "Αναζήτηση",
        "select": "Επιλογή",
        "snippets": "Αποσπάσματα",
        "title": "Τίτλος",
        "titleError": "Συμπλήρωσε έναν τίτλο"
      }
    }
  }
}
